var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized } from '@lit/localize';
import '../div/LoadingDiv'; // Import the LoadingDiv component
import '../div/FlowLoading'; // Import the FlowLoading component
let LoadingModal = class LoadingModal extends LitElement {
    constructor() {
        super(...arguments);
        this.message = null;
        this.nodeExecution = null;
        this.connecting = false;
        this.variant = 'primary';
    }
    render() {
        if (this.connecting || this.nodeExecution) {
            return html `
        <div class="content-wrapper">
          <flow-loading
            .phase=${this.nodeExecution ? 'running' : 'connecting'}
            .nodeExecution=${this.nodeExecution}
            .variant=${this.variant}
          ></flow-loading>
        </div>
      `;
        }
        else if (this.message) {
            return html `
        <div class="content-wrapper">
          <loading-div .message=${this.message}></loading-div>
        </div>
      `;
        }
        else {
            return html `
        <loading-div
          .message=${this.message}
        ></loading-div>
      `;
        }
    }
};
LoadingModal.styles = css `
    :host {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1000;
    }

    .content-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      background-color: rgba(255, 255, 255, 0.9); /* Semi-transparent background for better readability */
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      z-index: 1001;
    }

    .message {
      margin-top: 1rem;
      font-size: 1.2rem;
      color: #333; /* Dark text for contrast */
      text-align: center;
    }

    flow-loading {
      width: 320px;
      height: 320px;
    }
  `;
__decorate([
    property({ type: String })
], LoadingModal.prototype, "message", void 0);
__decorate([
    property({ type: Object })
], LoadingModal.prototype, "nodeExecution", void 0);
__decorate([
    property({ type: Boolean })
], LoadingModal.prototype, "connecting", void 0);
__decorate([
    property({ type: String })
], LoadingModal.prototype, "variant", void 0);
LoadingModal = __decorate([
    localized(),
    customElement('loading-modal')
], LoadingModal);
export { LoadingModal };
//# sourceMappingURL=LoadingModal.js.map